import { usePage } from '@inertiajs/react';

const TESTIMONIALS = [
    {
        quote: 'I was originally with Fora Travel and decided to switch over with LuxRally Travel after reading an article about LuxRally and David Eisen. His work ethic is very much in line with who I am and the service I strive to provide clients. LuxRally has so much to offer, I love their trainings, they have an amazing support team, a great platform that really gives us a competitive edge and not only is my commission split higher but so is my % rate.',
        name: 'Eileen T.',
        context: 'Advisor',
    },
    {
        quote: "From our proprietary booking system giving us an edge on tech, ease of collaboration, bi-monthly meetings with our CEO and CMO, innovative and extensive training program, our in house concierge that gives a truly high touch experience for our clients, to the fact that we don't have supplier loyalty — giving us access to the best rates around — all while charging zero fees to us as agents or to our clients.",
        name: 'Rachel G.',
        context: 'Advisor',
    },
    {
        quote: 'LuxRally has been an amazing company to work for. The educational materials provided and mentoring from other agents and staff is unheard of. Not to mention, there are no fees at all to utilize all their amazing resources.',
        name: 'Stefanie C.',
        context: 'Advisor',
    },
];

interface HarReviews {
    count?: number;
    rating?: number;
}

function formatRating(rating: number): string {
    return Number.isInteger(rating) ? `${rating}.0` : rating.toFixed(1);
}

export function AdvisorTestimonials() {
    const { harReviews } = usePage<{ harReviews?: HarReviews }>().props;
    const count = harReviews?.count ?? 68;
    const rating = harReviews?.rating ?? 5.0;

    return (
        <section id="testimonials" className="scroll-mt-20 bg-[#0b2222]">
            <div className="mx-auto max-w-6xl px-6 py-20 sm:py-24 lg:py-28">
                <div className="mb-16">
                    <span className="lux-caps lux-caps-lg mb-4 block text-[#F5F5F5]/60">From Our Advisors</span>
                    <h2 className="font-didot text-3xl text-[#F5F5F5] sm:text-4xl">What our advisors say.</h2>
                </div>

                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    {TESTIMONIALS.map((t, i) => (
                        <div
                            key={i}
                            className="group flex flex-col rounded-sm border border-[#F5F5F5]/[0.08] p-10 transition-colors duration-300 hover:border-[#F5F5F5]/15"
                        >
                            <div className="mb-4 flex gap-1" aria-label="5 out of 5 stars">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <svg key={s} viewBox="0 0 20 20" fill="currentColor" className="h-3.5 w-3.5 text-[#F5F5F5]/40">
                                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                    </svg>
                                ))}
                            </div>
                            <p className="flex-1 text-base leading-relaxed text-[#F5F5F5]/75">{t.quote}</p>
                            <p className="lux-caps lux-caps-sm mt-8 text-[#F5F5F5]/60">
                                {t.name} — {t.context}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-10 flex items-center justify-center gap-3">
                    <span className="text-sm text-[#F5F5F5]/60">
                        {formatRating(rating)} stars across {count} reviews on
                    </span>
                    <a
                        href="https://hostagencyreviews.com/hosts/luxrally-travel/reviews"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block transition-opacity hover:opacity-75"
                    >
                        <img src="/har-logo.png" alt="Host Agency Reviews" className="h-7 w-auto object-contain opacity-50 brightness-0 invert" />
                    </a>
                </div>
            </div>
        </section>
    );
}
